import styled from "styled-components";

interface IProps {
  hidden?: boolean;
  required?: boolean;
  rm_margin?: boolean;
}

export const Flex = styled.div<IProps>`
  display: ${(props: IProps) => (props.hidden ? "none" : "flex")};
  align-items: center;
  justify-content: center;
  margin-top: 10px;
`;

export const Label = styled.label<IProps>`
  font-variant: tabular-nums;
  line-height: 1.5715;
  position: relative;
  display: inline-flex;
  /* &::before {
    content: "*";
    position: absolute;
    display: ${({ required }: IProps) => (required ? "flex" : "none")};
    top: 4px;
    left: -10px;
    color: #ff4d4f;
    font-size: 14px;
    font-family: SimSun, sans-serif;
    line-height: 1;
  } */
  @media (max-width: 576px) {
    width: 330px;
  }
`;

export const InputContent = styled.div<IProps>`
  width: 100%;
  display: ${(props: IProps) => (props.hidden ? "none" : "flex")};
  align-items: center;
  justify-content: center;
  margin-top: 10px;
  margin-bottom: ${(props: IProps) => (props?.rm_margin ? "0" : "40px")};
  flex-wrap: wrap;
  gap: 8px;
  @media (max-width: 576px) {
    flex-direction: column;
  }
  @media (max-width: 400px) {
    align-items: inherit;
  }
`;

export const InputDefault = styled.input`
  border: 1px solid #d9d9d9;
  border-radius: 10px;
  font-variant: tabular-nums;
  list-style: none;
  display: inline-block;
  color: rgba(0, 0, 0, 0.85);
  padding: 4px 11px;
  width: 100%;
  max-width: 191.6px;
  &:hover {
    border-color: #ffaf40;
    border-right-width: 1px;
  }

  @media (max-width: 576px) {
    max-width: 330px;
  }
`;

export const TotalHoursContainer = styled.div`
  /*margin-top: 10px;
  display: flex;
  flex-direction: column;
  align-items: baseline;
  padding-left: 5px;*/
  padding-left: 5px;
`;

export const TotalHours = styled.div`
  margin-left: 6px;
  font-size: 18px;
  font-weight: 600;
  color: var(--light-orange);
`;
